import _ from 'lodash';
import { createSelector } from 'reselect';
import { getMainItemOverlayOpacity } from '../../../../../../shared/selectors/app-settings';
export var getOpacityStyles = createSelector(getMainItemOverlayOpacity, function (mainItemOverlayOpacity) {
    var opacity = _.round(mainItemOverlayOpacity / 100, 2);
    return {
        backgroundColor: "rgba(0,0,0," + opacity + ")",
    };
});
